import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SearchUsersForImpersonationQueryVariables = Types.Exact<{
  input: Types.GetPeopleInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type SearchUsersForImpersonationQuery = { __typename?: 'Query', People: { __typename?: 'Employees', totalCount: number, objects: Array<{ __typename?: 'Employee', id: number, firstName: string, lastName: string, userType: Types.UserType, email?: string | null, phoneNumber?: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, roles: Array<{ __typename?: 'Role', id: number, name: string }> }> } };


export const SearchUsersForImpersonationDocument = gql`
    query SearchUsersForImpersonation($input: GetPeopleInput!, $pagination: PaginationInput) {
  People(input: $input, pagination: $pagination) {
    totalCount
    objects {
      id
      firstName
      lastName
      userType
      email
      phoneNumber
      locations {
        id
        name
      }
      roles {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchUsersForImpersonationQuery__
 *
 * To run a query within a React component, call `useSearchUsersForImpersonationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersForImpersonationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersForImpersonationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchUsersForImpersonationQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersForImpersonationQuery, SearchUsersForImpersonationQueryVariables> & ({ variables: SearchUsersForImpersonationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersForImpersonationQuery, SearchUsersForImpersonationQueryVariables>(SearchUsersForImpersonationDocument, options);
      }
export function useSearchUsersForImpersonationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersForImpersonationQuery, SearchUsersForImpersonationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersForImpersonationQuery, SearchUsersForImpersonationQueryVariables>(SearchUsersForImpersonationDocument, options);
        }
export type SearchUsersForImpersonationQueryHookResult = ReturnType<typeof useSearchUsersForImpersonationQuery>;
export type SearchUsersForImpersonationLazyQueryHookResult = ReturnType<typeof useSearchUsersForImpersonationLazyQuery>;
export type SearchUsersForImpersonationQueryResult = Apollo.QueryResult<SearchUsersForImpersonationQuery, SearchUsersForImpersonationQueryVariables>;